import React from 'react'
import Layout from '../../Layout'
import First_pane from './First_pane'
import Interior from '../../Layout/Block/Interior'

const Biote_capri = () => {
  return (
     <Layout>
        <First_pane />
        < Interior />
     </Layout>
  )
}

export default Biote_capri